<template lang="pug">
#GlobalHeader
  .head
    .head-inline
      p.tagline ワオ・コーポレーションの個別指導塾フランチャイズオーナー募集
      p.wao
        a(href='http://www.wao-corp.com/' target='_blank')
          img(:src='`${publicPath}assets/images/head_wao_logo.png`' width="136" height="17" alt="ワオ・コーポレーション")
  .header
    p.logo
      a(href='/')
        img(:src='`${publicPath}assets/images/logo_axis.png`' alt='個別指導 Axisフランチャイズオーナー募集')
    p.owner
      img(:src='`${publicPath}assets/images/header_txt_owner.png`' width='215' height='34' alt='フランチャイズオーナー募集')
    ul.function-nav.all-rover
      li
        a(href='/info-sessions/')
          img(:src='`${publicPath}assets/images/function_explanation.png`' width='170' height='33' alt='説明会のご予約')
      li
        a(href='/contact/request/' target='_blank')
          img(:src='`${publicPath}assets/images/function_request.png`' width='131' height='33' alt='資料請求')
    p.tel
      img(:src='`${publicPath}assets/images/header_txt_tel.png`' width='311' height='28' alt='電話でのお問い合わせはこちら フリーコール0120-188-335 10時～19時(土・日・祝を除く)')
  .header-nav
    ul
      li
        a(href='/') HOME
      li
        a(href='/contact/request/' target='_blank') お問い合わせ
      li
        a(href='/question/') よくあるご質問
      li
        a(href='/wao/company/') 会社概要
      li
        a(href='/sitemap/') サイトマップ
</template>

<style lang="scss">
@import url(../assets/css/jquery.sidr.dark.css);

@media screen and (max-width: 480px) {
    #GlobalHeader .header .logo {
        margin-bottom: 0 !important;
    }
}

#GlobalHeader ul, #GlobalHeader ol {
    padding-left: 0;
}

#GlobalNavi ul li {
    a {
        display: inline-block;
    }

    .drop {
        overflow: visible;
        display: none;
        opacity: 0;
        height: 0;
        transition: 250ms;

        &.show {
            display: block;
            opacity: 1;
            height: auto;
            transition: 250ms;
        }

        li {
            line-height: 0;
        }
    }
}

body.sidr-open.sidr-right-open {
    right: 260px;
    width: 100vw;
    position: absolute;
    overflow-y: hidden;
    height: 100vh;

    .sidr.right {
        right: 0;
    }
}

</style>

<script>
export default {
    data () {
        return {
            publicPath: process.env.BASE_URL
        }
    }
}
</script>